<div class="container flex flex-col md:grid md:grid-cols-3 gap-4">
    <div class="dark-overlay animate-pulse block h-[21rem] w-full md:col-span-2"></div>

    <div class="flex flex-col gap-4 h-[21rem] md:h-full items-stretch">
        <div class="dark-overlay animate-pulse block flex-grow w-full"></div>
        <div class="dark-overlay animate-pulse block flex-grow w-full"></div>
    </div>
</div>